export default "__VITE_ASSET__ByocTFt___"